import Footer from "Components/Footer/Footer";

export default Footer;
